import { render } from "./TrendItemRow.vue?vue&type=template&id=2de096ce&scoped=true"
import script from "./TrendItemRow.vue?vue&type=script&lang=js"
export * from "./TrendItemRow.vue?vue&type=script&lang=js"

import "./TrendItemRow.vue?vue&type=style&index=0&id=2de096ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de096ce"]])

export default __exports__